import { connect } from 'react-redux'

import Actions from '../../Actions/Creators'
import StudentList from './Component/StudentList'
import Phi from '../../Phi/Phi'


const mapStateToProps = (state, ownProps) => ({
    studentHeader: state.student.studentHeader,
    studentList: state.student.studentList,
    totalStudent: state.student.totalStudent,
    pdfContent: state.student.pdfContent,
    currentProgram: state.organization.currentProgram,    
    programs: state.organization.programs,
    startNodeMap: state.organization.startNodeMap
})


const mapDispatchToProps = (dispatch) => ({
    fetchStudentList: payload => dispatch(Actions.fetchStudentList(payload)),
    getProgramByOrganization: organization_id => dispatch(Actions.getProgramByOrganization(organization_id)),
    getStudentReport: (reportType, config) => dispatch(Actions.getStudentReport(reportType, config)),
    getBulkStudentReport: (reportType, config) => dispatch(Actions.getBulkStudentReport(reportType, config))
})


export default connect(mapStateToProps, mapDispatchToProps)(StudentList)